<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <footer :class="{grey: color === 'grey'}">
    <div class="footer-wrapper flex">
      <div class="footer-logo" v-if="$mq !== 'sm'">

      </div>
      <div class="footer-info" v-if="$mq !== 'sm'">
        <ul>
          <li>상호명 : 주식회사 휴식</li>
          <li>대표 : 김환종</li>
          <li>사업자 등록번호 : 646-86-01056</li>
        </ul>
        <ul>
          <li>주소 : 서울틀별시 중랑구 면목로 92라길 7-6 YMS타워 D동 2층</li>
          <li>문의 : 02-911-9051</li>
        </ul>
        <ul>
          <li>이메일 : official@huesik.co.kr</li>
        </ul>

        <ul>
          <li>Copyright HUESIK All Right Reserved</li>
        </ul>
      </div>
      <div class="footer-info" v-if="$mq === 'sm'">
        <ul>
          <li>Copyright HUESIK All Right Reserved</li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'DefaultFooter',
    props: {
      color: {
        type: String,
        default: 'white'
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  footer {
    height: 20rem;
    padding: 3.85rem 0 3.8rem 0;
    justify-content: center;
    display: flex;

    &.grey {
      background: @very-light-pink;
    }

    .footer-logo {
      width:9.3rem;
      height: 9.15rem;
      /*background: black;*/
      padding-right:1.2rem;
      background: url('../../assets/images/ex-footer.png') no-repeat no-repeat center center;
    }

    .footer-info {
      padding-left:1.2rem;
      font-size: 1.2rem;
      font-weight: bold;
      color: @brown-grey;

      ul {
        display: flex;
        padding: 0.8rem 0;

        &:first-child {
          padding-top:0;
        }

        &:last-child {
          padding-bottom:0;
        }

        li {
          padding: 0 1rem;
        }
      }
    }
  }
  @media all and (-ms-high-contrast:none)
  {
    /*.foo { color: green } !* IE10 *!*/
    *::-ms-backdrop, footer { height: 27rem; } /* IE11 */
  }
</style>

<!-- Tablet Media Query -->
<style scoped lang="less">
  @media screen and (max-width: 1366px) {
    footer {
      height: 10rem;
      padding-bottom: 1rem;
    }
  }
</style>

<style lang="less" scoped>
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    footer {
      height: auto;
      padding: 3rem 0;
    }
  }
</style>

